import React, { useEffect, useState } from 'react'
import { base_loading_time, url } from '../../base/Variables'
import { Rupee } from '../index'
import { LazyAxios, LazyImage, catchError, DeleteIcon, EditIcon, ErrorUp, getToken, LikeIcon, StartLoading, SuccessUp, getDiscount, slugify } from '../../base'
import { useNavigate } from 'react-router-dom'

const InquiryCartItem = React.memo(({ item, updateItems, getAllInquiryCartItem, setPerror, }) => {

    const [quantity, setQuantity] = useState(0)
    const [error, setError] = useState(null)
    const [success, setSuccess] = useState(null)
    const [loading, setLoading] = useState(false)
    const baseUrl = `${url}/api/v1/wholesale/inquiryCart/`
    const navigate = useNavigate()

    async function updateItem() {
        setLoading(true)
        try {
            const token = getToken()
            const axios = await LazyAxios()
            const request = await axios.put(baseUrl, {
                'product_id': item.product,
                'inquiry_id': item.inquiry,
                'quantity': Number(quantity)
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            if (request.data && request.data.success_message) {
                updateItems(request.data.data, 'update')
                setSuccess('Product inquiry updated successfully')
            }
            else if (request.data && request.data.error_message === 'Oops ! Products in the inquiry has been changed.') {
                getAllInquiryCartItem()
            }
            else if (request.data && request.data.error_message) {
                setError(request.data.error_message)
            }
        }
        catch (error) {
            setPerror(catchError(error).error_message)
        }
        finally {
            const timeout = setTimeout(() => {
                setLoading(false)
            }, [base_loading_time])

            return () => clearTimeout(timeout)
        }
    }

    async function deleteItem() {
        setLoading(true)
        try {
            const token = getToken()
            const axios = await LazyAxios()
            const request = await axios.delete(baseUrl, {
                params: {
                    'product_id': item.product,
                    'inquiry_id': item.inquiry
                },
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            if (request.data && request.data.success_message) {
                setSuccess('Product has been deleted from cart !')
                const time = setTimeout(() => {
                    updateItems(item, 'delete')
                }, [base_loading_time])

                return () => clearTimeout(time)
            }
        }
        catch (error) {
            setPerror(catchError(error).error_message)
        }
        finally {
            const timeout = setTimeout(() => {
                setLoading(false)
            }, [base_loading_time])
            return () => clearTimeout(timeout)
        }
    }

    async function moveToWishList() {
        setLoading(true)
        try {
            const token = getToken()
            const axios = await LazyAxios()
            const request = await axios.delete(baseUrl, {
                params: {
                    'product_id': item.product,
                    'inquiry_id': item.inquiry,
                    'wishlist': true
                },
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            console.log(request.data)
            if (request.data && request.data.success_message) {
                setSuccess('Product moved to wishlist !')
                const time = setTimeout(() => {
                    updateItems(item, 'delete')
                }, [base_loading_time])
                return () => clearTimeout(time)
            }
            else if (request.data && request.data.error_message) {
                getAllInquiryCartItem()
            }
        }
        catch (error) {
            setPerror(catchError(error).error_message)
        }
        finally {
            const timeout = setTimeout(() => {
                setLoading(false)
            }, [base_loading_time])

            return () => clearTimeout(timeout)
        }
    }

    useEffect(() => {
        setQuantity(item.quantity)
    }, [item])

    console.log(item.quantity, quantity, item)
    return (
        <>
            {item && <div className='cartItem'>
                <div className='d-flex' style={{ rowGap: '10px' }}>
                    <div>
                        <div className='imagediv'>
                            <LazyImage src={`${url}${item.product_image}`} alt={item.product_name} />
                        </div>
                    </div>
                    <div className='ms-2 w-100 d-flex' style={{ flexDirection: 'column', justifyContent: 'space-evenly', paddingRight: '5px' }}>
                        <div className='h7 scolor truncate-2' style={{ cursor: 'pointer' }} onClick={() => navigate(`/product/${slugify(item.product_name, item.product)}/details/`)}>{item.product_name}</div>
                        <div className='h7 truncate-1' style={{ cursor: 'pointer' }} onClick={() => navigate(`/shop/${slugify(item.seller, item.shop_id, false)}/details/`)}>Seller : {item.seller}</div>
                        <div className='h7 d-flex gap-1 align-items-center'><del><Rupee amount={item.product_mrp} /></del><Rupee className='ms-2' amount={item.product_price} />  <span className='smallText pcolor'>{`(${getDiscount(item.product_mrp, item.product_price)}% off)`}</span></div>
                        <div className='d-flex gap-2'>
                            <label className='mt-0'>Quanity : </label>
                            <input style={{ textAlign: 'center' }} type='number' value={quantity} onChange={(e) => setQuantity(e.target.value)} min={0} max={100} />
                        </div>

                    </div>
                </div>

                <div className='buttonTab'>
                    <div className='h7' style={{ borderRight: '1px solid rgba(128, 128, 128, 0.308)' }} data-bs-toggle="modal" data-bs-target={`#exampleModal${item.id}`}><DeleteIcon style={{ width: '15px', marginRight: '10px' }} /> Delete</div>
                    <div className='h7' style={{ borderRight: '1px solid rgba(128, 128, 128, 0.308)' }} onClick={() => moveToWishList()}><LikeIcon style={{ width: '19px', marginRight: '10px' }} /> Wishlist</div>
                    <div className={`h7 ${item.quantity === quantity ? 'd-none' : 'd-flex'}`} onClick={() => updateItem()}><EditIcon style={{ width: '16px', marginRight: '6px' }} /> Update Item</div>
                </div>



                <div className="modal fade" id={`exampleModal${item.id}`} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body h6">
                                Do you want to delete product inquiry ?
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="secondryButton h7" onClick={() => deleteItem()} data-bs-dismiss="modal">Delete</button>
                                <button type="button" className="primaryButton h7" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    loading ? <StartLoading /> :
                        error ? <ErrorUp message={error} removeMessage={setError} /> : success ? <SuccessUp message={success} removeMessage={setSuccess} /> : <></>
                }
            </div>}
        </>
    )
})

export default InquiryCartItem


// https://www.melonstube.com/category/indian-blowjob